import React from 'react';
import { popupOpenService } from '../../services/popupOpenService';
import { POPUP_KEY_CREATE_RECIPE } from '../../constant';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const CreateNewRecipeButton = () => {
    const { i18n } = useTranslation();
    const openCreateRecipePopup = () => {
        popupOpenService.callToOpen(POPUP_KEY_CREATE_RECIPE);
    };

    return (
        <Button variant="outline" className="recipe__button" onClick={openCreateRecipePopup}>
            {i18n.t('app.page.recipe.addRecipe')}
        </Button>
    );
};

export default CreateNewRecipeButton;
